module.exports = __webpack_public_path__ + "static/Tomer-Gabel.0961605f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Tomer-Gabel.jpg
// module id = 119
// module chunks = 189410179417045 240012292094641